import { render, staticRenderFns } from "./OrganizationUserManagement.vue?vue&type=template&id=d788e0a0&"
import script from "./OrganizationUserManagement.vue?vue&type=script&lang=js&"
export * from "./OrganizationUserManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports